import { useState } from 'react'
import { Download, DollarSign, CheckCircle, Clock, XCircle } from 'lucide-react'

const TXS = [
  { id: 'TXN-8841', user: 'Sarah Mitchell', amount: '$299.00', method: 'Stripe', plan: 'Enterprise', status: 'success', date: 'May 4, 2025' },
  { id: 'TXN-8840', user: 'James Holloway', amount: '$79.00', method: 'PayPal', plan: 'Pro', status: 'success', date: 'May 4, 2025' },
  { id: 'TXN-8839', user: 'Priya Sharma', amount: '$19.00', method: 'Stripe', plan: 'Starter', status: 'pending', date: 'May 4, 2025' },
  { id: 'TXN-8838', user: 'Luca Martini', amount: '$299.00', method: 'Stripe', plan: 'Enterprise', status: 'failed', date: 'May 3, 2025' },
  { id: 'TXN-8837', user: 'Emily Chen', amount: '$79.00', method: 'Razorpay', plan: 'Pro', status: 'success', date: 'May 3, 2025' },
  { id: 'TXN-8836', user: 'Daniel Okafor', amount: '$0.00', method: '—', plan: 'Free', status: 'success', date: 'May 2, 2025' },
  { id: 'TXN-8835', user: 'Anika Patel', amount: '$19.00', method: 'Stripe', plan: 'Starter', status: 'success', date: 'May 2, 2025' },
]
const STATUS = {
  success: { cls: 'badge-active', l: 'Paid' },
  pending: { cls: 'badge-pending', l: 'Pending' },
  failed: { cls: 'badge-danger', l: 'Failed' },
}

export default function Transaction() {
  const [filter, setFilter] = useState('all')
  const visible = filter === 'all' ? TXS : TXS.filter(t => t.status === filter)

  const totalRevenue = TXS
    .filter(t => t.status === 'success')
    .reduce((s, t) => s + parseFloat(t.amount), 0)
    .toFixed(2)

  const stats = [
    { label: 'Total Revenue', value: `$${128}`, icon: DollarSign, color: '#4F46E5', colorGlow: 'rgba(79,70,229,0.18)', trend: '+18%', bar: 85, trendDir: 'up' , trendColor: '#4F46E5', variant: 'indigo' },
    { label: 'Successful', value: TXS.filter(t => t.status === 'success').length, icon: CheckCircle, color: '#10B981', colorGlow: 'rgba(16,185,129,0.15)', trend: '+5%', bar: Math.round(TXS.filter(t => t.status === 'success').length / TXS.length * 100), trendColor: '#10B981', variant: 'green' },
    { label: 'Pending', value: TXS.filter(t => t.status === 'pending').length, icon: Clock, color: '#F59E0B', colorGlow: 'rgba(245,158,11,0.15)', trend: '1%', bar: Math.round(TXS.filter(t => t.status === 'pending').length / TXS.length * 100), trendDir: 'neutral', trendColor: '#F59E0B', variant: 'amber' },
    { label: 'Failed', value: TXS.filter(t => t.status === 'failed').length, icon: XCircle, color: '#EF4444', colorGlow: 'rgba(239,68,68,0.15)', trend: '-1%', bar: Math.round(TXS.filter(t => t.status === 'failed').length / TXS.length * 100), trendDir: 'down', trendColor: '#EF4444', variant: 'red'},
  ]

  return (
    <div className="dash-page page-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 'var(--space-md)' }}>
        <h1 className="page-title">Transactions</h1>
        <button className="btn btn-outline"><Download size={14} /> Export CSV</button>
      </div>

      <div className="stats-grid cols-4">
        {stats.map(s => (
          <div key={s.label} className={`stat-card stat-card--${s.variant}`}>
            <span style={{ "position": "absolute", "top": "0px", "right": "0px", "width": "110px", "height": "110px", "border-radius": "50%", "background": s.colorGlow, "filter": "blur(30px)", "transform": "translate(30%, -30%)", "pointer-events": "none" }}></span>
            <div className="stat-card-header">
              <div className="stat-card-icon" style={{ background: s.colorGlow, color: s.color, border: `1px solid ${s.colorGlow}` }}>
                <s.icon size={15} strokeWidth={1.8} />
              </div>
              <span className="stat-card-trend"
                style={{ color: s.trendColor, background: `${s.trendColor}15`, border: `1px solid ${s.colorGlow}` }}>
                {s.trend}
              </span>
            </div>
            <div className="stat-card-value">{s.value}</div>
            <div className="stat-card-label">{s.label}</div>
            <div style={{ "position": "absolute", "bottom": "0px", "left": "0px", "right": "0px", "height": "2px", background: `linear-gradient(90deg,${s.color}88,transparent)`, "border-radius": "0 0 var(--radius-lg) var(--radius-lg)" }}></div>
          </div>
        ))}
      </div>

      <div className="card" style={{ padding: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)', padding: 'var(--space-md) var(--space-lg)', borderBottom: '1px solid var(--border)', flexWrap: 'wrap' }}>
          <span style={{ fontSize: 'var(--fs-md)', fontWeight: 600, color: 'var(--text1)', flex: 1 }}>Transaction History</span>
          <div className="view-tabs" style={{ margin: 0 }}>
            {['all', 'success', 'pending', 'failed'].map(f => (
              <button key={f} className={`vtab${filter === f ? ' active' : ''}`} onClick={() => setFilter(f)}>
                {f.charAt(0).toUpperCase() + f.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr><th>ID</th><th>User</th><th>Plan</th><th>Amount</th><th>Method</th><th>Status</th><th>Date</th></tr>
            </thead>
            <tbody>
              {visible.map(t => (
                <tr key={t.id}>
                  <td style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--fs-xs)', color: 'var(--accent-hover)' }}>{t.id}</td>
                  <td style={{ fontWeight: 500, color: 'var(--text1)' }}>{t.user}</td>
                  <td><span className="badge badge-gold">{t.plan}</span></td>
                  <td style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, color: 'var(--color-green)' }}>{t.amount}</td>
                  <td style={{ color: 'var(--text2)' }}>{t.method}</td>
                  <td><span className={`badge ${STATUS[t.status].cls}`}>{STATUS[t.status].l}</span></td>
                  <td style={{ color: 'var(--text3)', fontSize: 'var(--fs-xs)' }}>{t.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <style>{`.dash-page{display:flex;flex-direction:column;gap:var(--space-lg);width:100%;}`}</style>
    </div>
  )
}